import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics } from "firebase/analytics";

// Your Firebase configuration
// TODO: Replace with your actual Firebase config values
const firebaseConfig = {
  apiKey: "AIzaSyAl4dc53Ff6d00W94AQGk4-S_A4FUTnAYI",
  authDomain: "pld-adastra.firebaseapp.com",
  projectId: "pld-adastra",
  storageBucket: "pld-adastra.firebasestorage.app",
  messagingSenderId: "1026617449889",
  appId: "1:1026617449889:web:d5a7c2907fd330bd5f7fe0",
  measurementId: "G-7JPCYQFTZ2"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// Initialize Firestore
export const db = getFirestore(app);